import Vue from 'vue'
import Vuex from 'vuex'

import map from './modules/map'
import user from './modules/user'

Vue.use(Vuex)
export default new Vuex.Store({
	modules: {
		map: map,
		user: user
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js